export default "__VITE_ASSET__roJY8SLN__"